// The "who is on this right now" chips, rendered beside a project's stage badge.
//
// One component for the tables and the project page, the same rule the stage
// badge and the alert cell follow: a project cannot read "Agent paused" in one
// place and nothing in another.
import { Badge } from "@recruiter/shared";

import { type HandlingSource, handlingChips } from "../lib/project-handling";
import "./handling-chips.css";

export function HandlingChips({
  project,
  size = "sm",
}: {
  project: HandlingSource;
  size?: "sm" | "md";
}) {
  const chips = handlingChips(project);
  // Most rows carry none. Render NOTHING rather than an empty wrapper, so the
  // Stage cell keeps the exact spacing it had before these existed.
  if (chips.length === 0) return null;
  return (
    <span className="hc-chips">
      {chips.map((chip) => (
        <Badge key={chip.key} variant={chip.variant} tone={chip.tone} size={size} title={chip.hint}>
          {chip.label}
        </Badge>
      ))}
    </span>
  );
}
